export * from './Banner';
export * from './HeaderMenu';
export * from './ProductComponents';
export * from './SocialWall';
export * from './Profile';
export * from './PlatformList';
export * from './FeatureList';
export * from './Footer';



/** WEBPACK FOOTER **
 ** ./src/common/index.js
 **/